import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link, useNavigate } from 'react-router-dom';
import Ofrendas from './pages/Ofrendas';
import Opciones from './pages/Opciones';
import ReporteEgresos from './pages/ReporteEgresos';
import ReporteIngresos from './pages/ReporteIngresos';
import Reporte from './pages/Reporte';
import Ingresos from './pages/Ingresos';
import Egresos from './pages/Egresos';
import ReporteConsolidado from './pages/ReporteConsolidado';
import Donantes from './pages/Donantes';
import Login from './pages/Login';
import CambiarPassword from './pages/CambiarPassword';
import './App.css';
import iglesiaImage from './images/paloma.jpg';
import { routerConfig } from './router/config';
import { UserProvider, useUser } from './lib/UserContext';

function AppContent() {
  const { currentUser, logout } = useUser();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
      <div className="app-container">
        <nav className="sidebar">
          <div className="sidebar-header">
            <h1>Iglesia Beraca</h1>
            <p>"Sirviendo con amor y fe"</p>
            {currentUser && (
              <div style={{ 
                marginTop: '1rem', 
                padding: '0.75rem', 
                background: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '8px',
                fontSize: '0.85rem'
              }}>
                <div style={{ fontWeight: 'bold', marginBottom: '0.25rem' }}>
                  <i className="fas fa-user" style={{ marginRight: '0.5rem' }}></i>
                  {currentUser.nombres} {currentUser.apellidos}
                </div>
                <div style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                  <i className="fas fa-shield-alt" style={{ marginRight: '0.5rem' }}></i>
                  {currentUser.rol}
                </div>
                <button
                  onClick={handleLogout}
                  style={{
                    marginTop: '0.5rem',
                    width: '100%',
                    padding: '0.5rem',
                    background: 'rgba(255, 255, 255, 0.2)',
                    border: '1px solid rgba(255, 255, 255, 0.3)',
                    borderRadius: '4px',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: '0.85rem'
                  }}
                >
                  <i className="fas fa-sign-out-alt" style={{ marginRight: '0.5rem' }}></i>
                  Cerrar Sesión
                </button>
              </div>
            )}
          </div>
          <ul>
            <li>
              <Link to="/">
                <i className="fas fa-home"></i>
                <span>Inicio</span>
              </Link>
            </li>
            <li>
              <Link to="/ofrendas">
                <i className="fas fa-gift"></i>
                <span>Ofrendas</span>
              </Link>
            </li>
          </ul>
        </nav>

        <main className="content">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/cambiar-password" element={<CambiarPassword />} />
            <Route
              path="/"
              element={
                <div className="welcome-container">
                  <img
                    src={iglesiaImage}
                    alt="Iglesia Beraca"
                    className="moving-image"
                  />
                  <h1 className="welcome-text">Bienvenidos a Iglesia Beraca</h1>
                  <p className="welcome-subtitle">Sistema de Administración Financiera</p>
                </div>
              }
            />
            <Route path="/ofrendas" element={<Ofrendas />} />
            <Route path="/opciones" element={<Opciones />} />
            <Route path="/ingresos" element={<Ingresos />} />
            <Route path="/egresos" element={<Egresos />} />
            <Route path="/reporteegresos" element={<ReporteEgresos />} />
            <Route path="/reporteingresos" element={<ReporteIngresos />} />
            <Route path="/reporteconsolidado" element={<ReporteConsolidado />} />
            <Route path="/reporte" element={<Reporte />} />
            <Route path="/donantes" element={<Donantes />} />
          </Routes>

          <footer className="footer">
            <p>© 2024 Iglesia - Softmarket. Todos los derechos reservados. - 1.1.4</p>
          </footer>
        </main>
      </div>
  );
}

function App() {
  return (
    <UserProvider>
      <Router {...routerConfig}>
        <AppContent />
      </Router>
    </UserProvider>
  );
}

export default App;
